import dataFetcher from "modules/dataFetcher";
import {
  RepositorySchema,
  ClusterProfileSchema,
  PackSchema,
} from "utils/schemas";
import api from "services/api";
import ModalService from "services/modal";
import ListActions from "modules/list/actions";
import store from "services/store";

export const editClusterProfile = new ModalService("editClusterProfile");
export const deleteProfileModal = new ModalService("deleteProfile");

export const repositoriesFetcher = dataFetcher({
  selectors: ["repositories", "pack"],
  schema: [RepositorySchema],
  async fetchData() {
    const response = await api.get("v1alpha1/registries/pack");
    return response.items;
  },
});

export const packNamesFetcher = dataFetcher({
  selectors: [
    "packName",
    (state) => state.forms.packSteps.data.type,
    (state) => state.forms.clusterprofile?.data?.cloudType,
  ],
  async fetchData([_, layerType, cloudType]) {
    const isBasicLayer = ["os", "cni", "csi", "k8s"].includes(layerType);
    let filters = `spec.layer=${layerType}`;
    if (!isBasicLayer) {
      filters = `spec.layer=addonANDspec.addonType=${layerType}`;
    }

    filters = `spec.cloudTypes_in_${cloudType},allAND${filters}`;
    const promise = api.get("v1alpha1/packs", { filters, limit: 200 });
    store.dispatch({
      type: "FETCH_LAYER_PACKS",
      promise,
      schema: {
        items: [PackSchema],
      },
    });
    const response = await promise;
    const items = response.items.reduce((accumulator, item) => {
      accumulator.add(item.spec.name);
      return accumulator;
    }, new Set());

    return [...items].map((name) => {
      const item = response.items.find((item) => item.spec.name === name);

      return {
        label: item.spec.displayName,
        value: name,
        name,
        logo: item.spec.logoUrl,
        registries: [
          ...new Set(
            response.items
              .filter((item) => item.spec.name === name)
              .map((item) => item.spec.registryUid),
          ),
        ],
        presets: item.spec.presets,
      };
    });
  },
});

export const configurePacksModal = new ModalService("configurePacks");

export const cloneClusterProfileModal = new ModalService("cloneClusterProfile");

export const profileListActions = new ListActions({
  initialQuery() {
    return {
      filters: "",
      limit: 20,
    };
  },
  fetchData(query) {
    return api.get("v1alpha1/dashboard/clusterprofiles", query);
  },
  schema: [ClusterProfileSchema],
});
